const MEASUREMENT_ID_PATTERN = /^G-[A-Z0-9]+$/

/**
 * 按当前构建环境加载 GA4。未配置 measurement id 时不采集，供本地开发使用。
 * @param {string|undefined} measurementId
 */
export function installVisualGameGa4(measurementId) {
  if (measurementId === undefined || measurementId === '') return false
  if (!MEASUREMENT_ID_PATTERN.test(measurementId)) {
    throw new Error(`Invalid Visual Game GA4 measurement id: ${measurementId}`)
  }

  const windowLike = /** @type {any} */ (globalThis)
  windowLike.dataLayer = windowLike.dataLayer || []
  windowLike.gtag = windowLike.gtag || function gtag() { windowLike.dataLayer.push(arguments) }
  windowLike.gtag('js', new Date())
  windowLike.gtag('config', measurementId, { send_page_view: false })

  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`
  // gtag.js 有 172 KB，放在首屏会和 main.js 抢带宽。上面的 gtag() 调用已经进了 dataLayer 队列，
  // 脚本晚到不会丢事件，所以推迟到 load 之后再下载。
  if (document.readyState === 'complete') document.head.appendChild(script)
  else globalThis.addEventListener('load', () => document.head.appendChild(script), { once: true })
  return true
}
